module.exports = __webpack_public_path__ + "static/media/values-header.2a830d38.jpeg";